import { defineComponent, ref, computed } from "vue";
import TuiSwiper from "../../common/base/Swiper.vue.mjs";
import TuiSwiperItem from "../../common/base/SwiperItem.vue.mjs";
import StreamList from "../common/StreamList/index.vue.mjs";
import useMultiStreamViewHook from "./useMultiStreamViewHook.mjs";
import { StreamPlayMode, StreamPlayQuality } from "../../../services/manager/mediaManager.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "MultiStreamViewH5",
  props: {
    maxColumn: null,
    maxRow: null,
    fillMode: null,
    streamInfoList: null,
    excludeStreamInfoList: null,
    streamPlayMode: null
  },
  emits: ["stream-view-dblclick"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const {
      column,
      row,
      isEqualPointsLayout,
      streamList,
      renderStreamInfoList,
      equalPointsLayoutStreamList,
      totalPageNumber,
      currentPageIndex
    } = useMultiStreamViewHook(props);
    const multiStreamViewRef = ref();
    function handleActiveIndexChange(index) {
      currentPageIndex.value = index;
    }
    function handleStreamViewDblclick(streamInfo) {
      emits("stream-view-dblclick", streamInfo);
    }
    function getStreamPlayMode(index) {
      return Math.abs(index - currentPageIndex.value) <= 1 ? StreamPlayMode.PLAY : StreamPlayMode.STOP;
    }
    const aspectRatio = computed(() => {
      if (isEqualPointsLayout.value) {
        return renderStreamInfoList.value.length > 1 ? "1:1" : "auto";
      }
      return "16:9";
    });
    return { __sfc: true, props, emits, column, row, isEqualPointsLayout, streamList, renderStreamInfoList, equalPointsLayoutStreamList, totalPageNumber, currentPageIndex, multiStreamViewRef, handleActiveIndexChange, handleStreamViewDblclick, getStreamPlayMode, aspectRatio, TuiSwiper, TuiSwiperItem, StreamList, StreamPlayMode, StreamPlayQuality };
  }
});
export {
  _sfc_main as default
};
